var l = (o, f, n) => new Promise((i, e) => {
  var t = (a) => {
    try {
      u(n.next(a));
    } catch (c) {
      e(c);
    }
  }, s = (a) => {
    try {
      u(n.throw(a));
    } catch (c) {
      e(c);
    }
  }, u = (a) => a.done ? i(a.value) : Promise.resolve(a.value).then(t, s);
  u((n = n.apply(o, f)).next());
});
import { a as w, r as p } from "./define-element-XpjsV6s1.js";
const r = w({});
function g(o = {}) {
  var i;
  if (typeof o == "string")
    try {
      o = JSON.parse(o);
    } catch (e) {
      console.error("Failed to parse configOverride as JSON", e), o = {};
    }
  r.value = n(
    Object.assign(
      {},
      r.value,
      ((i = window.OFFSET) == null ? void 0 : i.config) || {},
      o
    )
  );
  function f() {
    return l(this, null, function* () {
      var t;
      const e = yield p("config");
      r.value = n(
        Object.assign(
          {},
          r.value,
          e,
          ((t = window.OFFSET) == null ? void 0 : t.config) || {},
          o
        )
      );
    });
  }
  f();
  function n(e) {
    return Object.keys(e).forEach((t) => {
      const s = e[t];
      (typeof s == "string" || s instanceof String) && (s.toLowerCase() === "true" ? e[t] = !0 : s.toLowerCase() === "false" && (e[t] = !1));
    }), e;
  }
  return { config: r };
}
export {
  g as u
};
